"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IBTLogo = _interopRequireDefault(require("./assets/IBTLogo.svg"));
var _closeIcon = _interopRequireDefault(require("./assets/closeIcon.svg"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const HeaderWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 112px;\n  position: relative;\n  padding: 21px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
const ButtonClose = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  right: 0px;\n  top: 21px;\n"])));
const Logo = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: ", ";\n  max-height: 70px;\n"])), props => props.default ? "unset" : "140px");
const Header = _ref => {
  let {
    merchantLogoUrl,
    onClose,
    hideCloseButton,
    ...props
  } = _ref;
  const closeButton = /*#__PURE__*/_react.default.createElement(ButtonClose, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _closeIcon.default,
    onClick: onClose,
    "data-test": "closeButton"
  }));
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, props, !hideCloseButton && closeButton, /*#__PURE__*/_react.default.createElement(Logo, {
    className: "logo",
    src: merchantLogoUrl || _IBTLogo.default,
    default: !merchantLogoUrl,
    alt: "headerLogo"
  }));
};
exports.Header = Header;
Header.propTypes = {
  merchantLogoUrl: _propTypes.default.string,
  onClose: _propTypes.default.func,
  hideCloseButton: _propTypes.default.bool
};
Header.defaultProps = {
  merchantLogoUrl: null,
  onClose: null,
  hideCloseButton: false
};